import { render } from "./HappinessGuarantee.vue?vue&type=template&id=c3f53e0c"
const script = {}

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__